import { Person } from "../person/Person"
import { OpportunityModel } from "./OpportunityModel"

export class SupplierOpportunity {
    field_agent?: Person
    opportunity?: OpportunityModel

    constructor(d:any) {
        this.field_agent = d.field_agent ? Person.build(d.field_agent.person) : undefined
        this.opportunity = d.opportunity ? OpportunityModel.buildOpportunity(d.opportunity) : undefined
    }

    static build(d: any): SupplierOpportunity {
        return new SupplierOpportunity(d)
    }
}